import script from "./support-chat.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./support-chat.vue?vue&type=script&setup=true&lang=js"
export * from "./support-chat.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./support-chat.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__